import Vue from "vue";
import Bugsnag from "@bugsnag/js";
import BugsnagPluginVue from "@bugsnag/plugin-vue";
Bugsnag.start({
  apiKey: "e18400ba827596c50490558001b8e1f8",
  plugins: [new BugsnagPluginVue(Vue)],
  // releaseStage: "development",
  appVersion: process.env.VUE_APP_PACKAGE_VERSION,
});
// Bugsnag.refresh() for more than 10 errors
// Bugsnag.notify(new Error("Production Test error"));
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import VueGtag from "./plugins/vue-gtag";

Vue.config.productionTip = false;
new Vue({
  router,
  store,
  vuetify,
  VueGtag,
  render: (h) => h(App),
}).$mount("#app");
